// Конфигурация аналитики для frontend
// 

export interface CounterConfig {
  id: string | number;
  type: 'yandex' | 'mailru' | 'google';
  getFullCode(): string;
  getNoscriptCode(): string;
}

export interface AnalyticsConfig {
  id: number;
  getFullCode(): string;
  getNoscriptCode(): string;
  counters: CounterConfig[];
}

// Конфигурация Яндекс.Метрики
const YANDEX_METRIKA: CounterConfig = {
  id: 103667396,
  type: 'yandex',
  getFullCode: function(): string {
    return `
      (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${this.id}', 'ym');

      ym(${this.id}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", accurateTrackBounce:true, trackLinks:true});
    `;
  },
  getNoscriptCode: function(): string {
    return `<img src="https://mc.yandex.ru/watch/${this.id}" style="position:absolute; left:-9999px;" alt="" />`;
  }
};

// Конфигурация Top.Mail.Ru
const MAILRU_COUNTER: CounterConfig = {
  id: '3728789',
  type: 'mailru',
  getFullCode: function(): string {
    return `
      var _tmr = window._tmr || (window._tmr = []);
      _tmr.push({id: "${this.id}", type: "pageView", start: (new Date()).getTime()});
      (function (d, w, id) {
        if (d.getElementById(id)) return;
        var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
        ts.src = "https://top-fwz1.mail.ru/js/code.js";
        var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
      })(document, window, "tmr-code");
    `;
  },
  getNoscriptCode: function(): string {
    return `<img src="https://top-fwz1.mail.ru/counter?id=${this.id};js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" />`;
  }
};

export const ANALYTICS_CONFIG: AnalyticsConfig = {
  // ID основного счётчика (Яндекс.Метрика) - для обратной совместимости
  id: 103667396,
  
  // Полный код основного счётчика (Яндекс.Метрика) - для обратной совместимости
  getFullCode: function(): string {
    return YANDEX_METRIKA.getFullCode();
  },
  
  // Код для noscript тега основного счётчика - для обратной совместимости
  getNoscriptCode: function(): string {
    return YANDEX_METRIKA.getNoscriptCode();
  },
  
  // Массив всех активных счётчиков
  counters: [
    YANDEX_METRIKA,
    MAILRU_COUNTER
  ]
};
